import { render, staticRenderFns } from "./bubblechart.vue?vue&type=template&id=11465836&scoped=true&"
import script from "./bubblechart.vue?vue&type=script&lang=ts&"
export * from "./bubblechart.vue?vue&type=script&lang=ts&"
import style0 from "./bubblechart.vue?vue&type=style&index=0&id=11465836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11465836",
  null
  
)

export default component.exports